import { GpsType } from '../../../../../../global/components/layout/layout-models';

export enum AdoptionStep {
    QUESTIONS = 'QUESTIONS',
    DETAILS = 'DETAILS',
    REVIEW = 'REVIEW',
    INDEMNIFY = 'INDEMNIFY',
}

export enum AdoptionMemberType {
    Clergy = 'clergyEligible',
    Lay = 'layEligible',
    Both = 'clergyAndLayEligible',
}

export enum EmployerContributionStatusType {
    Scheduled = 'Scheduled',
    Discretionary = 'Discretionary',
}

export enum ContributionAmountType {
    Percentage = 'percent',
    Dollar = 'amount',
    Other = 'Other',
    None = 'None',
}

export enum ContributionType {
    Base = 'Base',
    Match = 'Match',
    OneTimePayment = 'OneTimePayment',
    PerPayrollPeriod = 'PerPayrollPeriod',
    BiMonthly = 'BiMonthly',
    Quarterly = 'Quarterly',
    TwiceYearly = 'TwiceYearly',
    Other = 'Other',
    None = 'None',
}

export interface PlanAdoptionSubmitModel {
}

export enum PlanAdoptionFormTypes {
    ClergyDb = 'ClergyDb',
    LayDb = 'LayDb',
    LayDc = 'laydc',
    Rsvp = 'rsvp',
}

export enum QccoStatus {
    Qualified = 'qualified',
    NotQualified = 'not-qualified',
    Error = 'error',
}

export interface PlanAdoptionContentModel {
    pageTitle: string;
    PageDescription: string;
    planAdoptionDetailTitle: string;
    adoptingInstitutionLabel: string;
    clientIdLabel: string;
    adoptionDateLabel: string;
    signHereLabel: string;
    signHereTooltip: string;
    signHereDescription: string;
    gpsType: GpsType;
    indemnifySuccessMessage?: string;
    indemnifySkippedMessage?: string;
}

export interface PlanFormModel {
    adoption_date: string;
    envelopeId?: string;
    indemnificationEnvelopeId?: string;
    complyEpiscopalChurchLayPensionSystem?: string;
}

export interface DBPlanAdoptionContentModel extends PlanAdoptionContentModel {
    indemnifyWarningTitleDc?: string;
    indemnifyWarningTitleRsvp?: string;
    indemnifyWarningMessage?: string;
    indemnifyWarningRsvpMessage?: string;
    indemnifyButtonText?: string;
    indemnifyButtonHelper?: string;    
    complyEpiscopalChurchLayPensionSystemQuestion?: string;
}

export interface DbPlanFormModel extends PlanFormModel {
}

export interface LayDcPlanAdoptionContentModel extends PlanAdoptionContentModel {
    cancelLabel: string;
    submitLabel: string;

    adoptingPlanStepperLabel: string;

    // QCCO Questions
    qccoQuestionTitle: string;
    qccoQuestion1Label: string;
    qccoQuestion2Label: string;
    qccoQuestion3Label: string;
    qccoQualificationStatusTitle: string;
    qccoQualificationStatusText: string;
    qccoQualificationYesStatusTitle: string;
    qccoQualificationYesStatusText: string;
    qccoQualificationNoStatusTitle: string;
    qccoQualificationNoStatusText: string;
    qccoQualificationErrorStatusTitle: string;
    qccoQualificationErrorStatusText: string;

    // Generic Plan Adoption Label
    adoptionInstitutionTitle: string;
    allowMultipleContributionsCheckBoxLabel: string;
    participantNameLabel: string;
    contributionTypeLabel: string;
    contributionPercentageLabel: string;
    contributionBaseLabel: string;
    contributionMatchLabel: string;
    contributionDollarLabel: string;
    contributionOneTimeLabel: string;
    contributionPerPayrollLabel: string;
    contributionBiMonthlyLabel: string;
    contributionQuarterlyLabel: string;
    contributionTwiceYearlyLabel: string;
    contributionOtherLabel: string;
    contributionAmountLabel: string;
    contributionEditLabel: string;
    contributionRemoveLabel: string;
    contributionAddEmployeeLabel: string;
    defaultBillPayorLabel: string;
    dioceseBillPayorLabel: string;
    institutionBillPayorLabel: string;
    adoptEmployerContributionTitle: string;

    // Adopt Details
    adoptDetailsTitle: string;
    adoptDetailsDescription: string;
    adoptEmployeeSalaryDeferText: string;
    adoptMemberTypeLabel: string;
    adoptMemberHelper: string;
    adoptMemberTypeClergyLabel: string;
    adoptMemberTypeLayLabel: string;
    adoptMemberTypeBothLabel: string;
    adoptEmployerContributionText: string;
    adoptMinScheduleHoursLabel: string;
    adoptMinScheduleHoursHelperText: string;
    adoptEmployerContributionStatusTitle: string;
    adoptEmployerContributionStatus: string;
    adoptEmployerContributionScheduledLabel: string;
    adoptEmployerContributionDiscrectionLabel: string;
    adoptEmployerBaseContributionLabel: string;
    adoptEmployerMatchContributionLabel: string;
    adoptEmployerContributionPercentageLabel: string;
    adoptEmployerContributioDollarsLabel: string;
    adoptMultipleContributionTitle: string;
    adoptMultipleContributionDescription: string;
    adoptMultipleContributionHelper: string;    

    adoptMultipleContributionWarningTitle: string;
    adoptMultipleContributionWarningMessage: string;

    percentageFormatMessage: string;
    amountFormatMessage: string;

    hasEmployerContributionStatus: boolean;
    hasMemberType: boolean;
    isEmployerContributionRequired: boolean;

    docuSignTemplateId: string;
    docuSignSignerRoleName: string;
    docuSignSubject: string;
    docuSignFinishText: string;
    docuSignRejectText: string;

    employerAuthorizationTitle: string;
    employerAuthorizationDescription: string;

    // Indemnification
    indemnifTitle: string;
    indemnifyDocuSignTemplateId: string;    
    indemnifyDocuSignSubject: string;
    indemnifyDocuSignSignLabel: string;
    indemnifyDocuSignFinishText: string;
    indemnifyDocuSignRejectText: string;
    indemnifyWarningTitle: string;
    indemnifyWarningInstruction1: string;
    indemnifyWarningInstruction2: string;
    indemnifySuccessLabel: string;
    indemnifySkippedLabel: string;
    complyEpiscopalChurchLayPensionSystemQuestion: string;    
    participantsMaxMessage: string;
}

export interface ParticipantModel {
    id: number;
    participant_name?: string;
    contribution_type?: ContributionType;
    contribution_value_type?: ContributionAmountType;
    contribution_amount?: number;
    contribution_percentage?: number;
    contribution_other?: string;
}

export interface LayDcPlanFormModel extends PlanFormModel {
    planId?: number;
    planHistoryId?: number;
    qccoStatusId?: string;

    qccoQuestion1: string;
    qccoQuestion2: string;
    qccoQuestion3: string;

    member_type?: AdoptionMemberType;

    minimum_scheduleds_hours: number;

    employer_contribution_status: EmployerContributionStatusType;

    employer_base_contribution_amount: number;
    employer_base_contribution_percentage: number;
    employer_base_contribution_amount_type?: ContributionAmountType;

    employer_match_contribution_amount: number;
    employer_match_contribution_percentage: number;
    employer_match_contribution_amount_type?: ContributionAmountType;

    allow_multiple_contributions: boolean;
    participants: ParticipantModel[];
    default_bill_payor: string;
    envelopeId?: string;
    indemnificationEnvelopeId?: string;
    complyEpiscopalChurchLayPensionSystem?: string;
    previousAdoptionDate?: string;
}

export interface RsvpPlanAdoptionContentModel extends LayDcPlanAdoptionContentModel {
}

export interface RsvpPlanFormModel extends LayDcPlanFormModel {
}

export interface PlanAdoptionRequest {
    values: PlanFormModel;
    clientId: string;    
}

export interface PlanCancelRequest extends PlanAdoptionRequest {
}

export interface PlanSubmitRequest extends PlanAdoptionRequest {
    signatureUrl?: string;
}

export interface DbPlanSubmitRequest {
    values: DbPlanFormModel;
    clientId: string;
    toggleDocusign: any;
}

export interface IContributionOverride {
    employee_name: string;
    contribution_type: string;
    contribution_amount?: string;
}